import { render, staticRenderFns } from "./ListTitipJual.vue?vue&type=template&id=ec6e10d4&"
import script from "./ListTitipJual.vue?vue&type=script&lang=js&"
export * from "./ListTitipJual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports